var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createTheme } from '@mui/material';
// TODO(Jenky): replace with colors in this same folder
import colors from '../legacy/colors';
import textDefinitions, { fontFamily } from '../textDefinitions';
var celesTheme = createTheme({
    palette: {
        'celes-default': {
            main: colors.neutral70
        },
        'celes-selected': {
            main: colors.neutral80
        },
        'celes-selectedSuccess': {
            main: colors.green60
        },
        'celes-error': {
            main: colors.red70
        },
        'celes-incomplete': {
            main: colors.yellow70
        },
        'celes-loading': {
            main: colors.neutral60,
            contrastText: colors.white
        }
    },
    components: {
        MuiButton: {
            variants: [
                /* ActionButton styles */
                {
                    props: { variant: 'action-loading', disabled: true },
                    style: {
                        cursor: 'default',
                        border: "2px solid ".concat(colors.neutral20),
                        '&.action-button.action-button *': {
                            color: colors.neutral40,
                            fill: "".concat(colors.neutral40, " !important")
                        }
                    }
                },
                {
                    props: { variant: 'action-loading', disabled: false },
                    style: {
                        cursor: 'default',
                        border: "2px solid ".concat(colors.neutral60),
                        backgroundColor: "".concat(colors.neutral60),
                        '&:hover': {
                            backgroundColor: colors.neutral60
                        },
                        '&.action-button.action-button *': {
                            color: colors.white,
                            fill: "".concat(colors.white, " !important")
                        }
                    }
                },
                {
                    props: { variant: 'action-default' },
                    style: {
                        backgroundColor: colors.white,
                        border: "2px solid ".concat(colors.neutral70),
                        '&.action-button.action-button *': {
                            color: colors.neutral70,
                            fill: "".concat(colors.neutral70, " !important")
                        }
                    }
                },
                {
                    props: { variant: 'action-default', disabled: true },
                    style: {
                        borderColor: colors.neutral20,
                        '&.action-button.action-button *': {
                            color: colors.neutral40,
                            fill: "".concat(colors.neutral40, " !important")
                        }
                    }
                },
                {
                    props: { variant: 'action-success' },
                    style: {
                        border: "2px solid ".concat(colors.green60),
                        backgroundColor: "".concat(colors.green60, " !important"),
                        '&.action-button.action-button *': {
                            color: colors.neutral0,
                            fill: "".concat(colors.neutral0, " !important")
                        }
                    }
                },
                {
                    props: { variant: 'action-success', disabled: true },
                    style: {
                        border: "2px solid ".concat(colors.neutral30),
                        backgroundColor: "".concat(colors.neutral30, " !important"),
                        borderColor: "".concat(colors.neutral30, " !important"),
                        '&.action-button.action-button *': {
                            color: colors.neutral0,
                            fill: "".concat(colors.neutral0, " !important")
                        }
                    }
                },
                {
                    props: { variant: 'action-incomplete' },
                    style: {
                        border: "2px solid ".concat(colors.yellow70),
                        '&.action-button.action-button *': {
                            color: colors.yellow70,
                            fill: "".concat(colors.yellow70, " !important")
                        }
                    }
                },
                {
                    props: { variant: 'action-incomplete', disabled: true },
                    style: {
                        border: "2px solid ".concat(colors.neutral30),
                        '&.action-button.action-button *': {
                            color: colors.neutral30,
                            fill: "".concat(colors.neutral30, " !important")
                        }
                    }
                },
                {
                    props: { variant: 'action-error' },
                    style: {
                        border: "2px solid ".concat(colors.red70),
                        '&.action-button.action-button *': {
                            fill: "".concat(colors.red70, " !important"),
                            color: colors.red70
                        }
                    }
                },
                {
                    props: { variant: 'action-error', disabled: true },
                    style: {
                        border: "2px solid ".concat(colors.neutral30),
                        '&.action-button.action-button *': {
                            color: colors.neutral30,
                            fill: "".concat(colors.neutral30, " !important")
                        }
                    }
                },
                {
                    props: { variant: 'action-selected' },
                    style: {
                        border: "2px solid ".concat(colors.neutral80),
                        backgroundColor: "".concat(colors.neutral80, " !important"),
                        borderColor: "".concat(colors.neutral80, " !important"),
                        '&.action-button.action-button *': {
                            color: colors.green20,
                            fill: "".concat(colors.green20, " !important")
                        }
                    }
                },
                {
                    props: { variant: 'action-selected', disabled: true },
                    style: {
                        border: "2px solid ".concat(colors.neutral60),
                        backgroundColor: "".concat(colors.neutral60, " !important"),
                        borderColor: "".concat(colors.neutral60, " !important"),
                        '&.action-button.action-button *': {
                            color: colors.proximaGreen5,
                            fill: "".concat(colors.proximaGreen5, " !important")
                        }
                    }
                },
                /* End ActionButton styles */
            ],
            styleOverrides: {
                root: {
                    '&.action-button': {
                        height: 36
                    }
                },
                startIcon: {
                    marginRight: 4
                }
            }
        },
        MuiInput: {
            styleOverrides: {
                root: __assign(__assign({ padding: '8px 6px' }, textDefinitions.body2Semibold), { '& > [class^="MuiInputAdornment-"]': {
                        marginTop: 2
                    }, '& .MuiInputAdornment-positionStart': {
                        marginRight: 12
                    }, '& .MuiInputAdornment-positionEnd': {
                        marginLeft: 12
                    } }),
                input: {
                    padding: '0px'
                },
                underline: {
                    '&:hover:hover::before': {
                        borderWidth: 1
                    },
                    '&:after': {
                        borderWidth: 1
                    }
                }
            }
        },
        MuiPopover: {
            styleOverrides: {
                paper: {
                    '&.popover-celes': {
                        borderRadius: 8,
                        border: "1px solid ".concat(colors.neutral20),
                        boxShadow: '0px 2px 4px 2px rgba(82, 99, 99, 0.12) !important'
                    }
                }
            }
        },
        MuiToggleButtonGroup: {
            styleOverrides: {
                root: {
                    '&:hover .toggle-switch-theme-celes': {
                        borderColor: colors.neutral60
                    }
                }
            }
        },
        MuiToggleButton: {
            styleOverrides: {
                root: {
                    '&.toggle-switch-theme-celes': {
                        borderWidth: 2,
                        transition: 'background-color .1s linear, color .1s linear, fill .1s linear, border-color .05s linear',
                        '&:not(:first-child)': {
                            marginLeft: -2
                        },
                        borderColor: colors.neutral20,
                        padding: '8px',
                        color: colors.neutral100,
                        '&.Mui-selected': {
                            borderColor: colors.neutral100,
                            backgroundColor: "".concat(colors.neutral100, " !important"),
                            '& svg *': {
                                fill: colors.white
                            },
                            zIndex: 1,
                            '&:hover': {
                                backgroundColor: colors.neutral90
                            }
                        },
                        '& svg *': {
                            fill: colors.neutral40
                        }
                    }
                }
            }
        },
        MuiTableHead: {
            variants: [
                {
                    props: { datatype: 'celes' },
                    style: {
                        '& .MuiTableCell-root': {
                            backgroundColor: colors.neutral0
                        }
                    }
                },
            ]
        },
        MuiTableRow: {
            variants: [
                {
                    props: { datatype: 'celes' },
                    style: {
                        '&.MuiTableRow-hover:hover': {
                            /* disables MUI default color */
                            background: 'inherit',
                            '& .MuiTableCell-root': {
                                /* disables hover effect from other variants */
                                background: 'inherit'
                            }
                        }
                    }
                },
            ]
        },
        MuiTypography: {
            styleOverrides: {
                root: {
                    '&.termina-header': {
                        fontFamily: "Termina, ".concat(fontFamily)
                    }
                }
            }
        }
    }
});
export default celesTheme;
